export enum RecordStatus {
  Active = 1,
  InactiveChanged = 2,
  InactiveChangeRequested = 3,
  InactiveChangeRejected = 4,
}
